module.exports = __webpack_public_path__ + "img/icey.dde2fd59.png";